/**
 * Utility to suppress unwanted console logs
 *
 * This function captures and filters out specified console logs
 * including all MUI logs and megamenu logs that are not relevant
 * for your application.
 */
import { LOCAL } from './config';

// Original console methods
const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;
const originalConsoleLog = console.log;

// Patterns to filter out
const SUPPRESSION_PATTERNS = [
  // Block all MUI logs
  /MUI/,

  // Block megamenu logs
  /^sessionStorage \d+:/,
  /^Warning: Failed prop type/,
  /^\d+\. Init Menu Started:/,
  /^\d+\. Cookie values :/,
  /^\d+\. Setting actingAsSubscriptionId:/,
  /^\d+\. Setting brightmlssubscriber:/,
  /^\d+\./,
];

/**
 * Initialize the console log suppression
 */
export const suppressUnwantedLogs = () => {
  if (LOCAL) {
    // blast for developer work
    return;
  }
  // Override console.error
  console.error = (...args) => {
    // Check if this is a message we want to suppress
    if (args.length > 0 && typeof args[0] === 'string') {
      for (const pattern of SUPPRESSION_PATTERNS) {
        if (pattern.test(args[0])) {
          return; // Suppress this message
        }
      }
    }
    // Otherwise, pass through to the original method
    originalConsoleError.apply(console, args);
  };

  // Override console.warn
  console.warn = (...args) => {
    // Check if this is a message we want to suppress
    if (args.length > 0 && typeof args[0] === 'string') {
      for (const pattern of SUPPRESSION_PATTERNS) {
        if (pattern.test(args[0])) {
          return; // Suppress this message
        }
      }
    }
    // Otherwise, pass through to the original method
    originalConsoleWarn.apply(console, args);
  };

  // Override console.log if needed
  console.log = (...args) => {
    // Check if this is a message we want to suppress
    if (args.length > 0 && typeof args[0] === 'string') {
      for (const pattern of SUPPRESSION_PATTERNS) {
        if (pattern.test(args[0])) {
          return; // Suppress this message
        }
      }
    }
    // Otherwise, pass through to the original method
    originalConsoleLog.apply(console, args);
  };
};

/**
 * Restore original console methods
 */
export const restoreConsoleMethods = () => {
  console.error = originalConsoleError;
  console.warn = originalConsoleWarn;
  console.log = originalConsoleLog;
};
